import _classCallCheck from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/sanjay/Qualtech/AvivaAgentPortal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Component as t, useRef as e, useEffect as n } from "react";
import i from "prop-types";
var s = "object" == ("undefined" == typeof window ? "undefined" : typeof window),
    r = s ? document : {},
    o = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mouseWheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange"];

function u(t, e) {
  var n;
  return function () {
    for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
      i[_key] = arguments[_key];
    }

    n && clearTimeout(n), n = setTimeout(function () {
      t.apply(void 0, i), n = null;
    }, e);
  };
}

function l(t, e) {
  var n = 0;
  return function () {
    var s = new Date().getTime();
    if (!(s - n < e)) return n = s, t.apply(void 0, arguments);
  };
}

var c = /*#__PURE__*/function (_t) {
  _inherits(c, _t);

  var _super = _createSuper(c);

  function c(t) {
    var _this;

    _classCallCheck(this, c);

    if (_this = _super.call(this, t), _this.state = {
      idle: !1,
      oldDate: +new Date(),
      lastActive: +new Date(),
      remaining: null,
      pageX: null,
      pageY: null
    }, _this.tId = null, _this.eventsBound = !1, t.debounce > 0 && t.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
    t.debounce > 0 ? _this._onAction = u(t.onAction, t.debounce) : t.throttle > 0 ? _this._onAction = l(t.onAction, t.throttle) : t.onAction ? _this._onAction = t.onAction : _this._onAction = function () {}, t.eventsThrottle > 0 ? _this._handleEvent = l(_this._handleEvent.bind(_assertThisInitialized(_this)), t.eventsThrottle) : _this._handleEvent = _this._handleEvent.bind(_assertThisInitialized(_this)), t.startOnMount || (_this.state.idle = !0), _this._toggleIdleState = _this._toggleIdleState.bind(_assertThisInitialized(_this)), _this.reset = _this.reset.bind(_assertThisInitialized(_this)), _this.pause = _this.pause.bind(_assertThisInitialized(_this)), _this.resume = _this.resume.bind(_assertThisInitialized(_this)), _this.getRemainingTime = _this.getRemainingTime.bind(_assertThisInitialized(_this)), _this.getElapsedTime = _this.getElapsedTime.bind(_assertThisInitialized(_this)), _this.getLastActiveTime = _this.getLastActiveTime.bind(_assertThisInitialized(_this)), _this.isIdle = _this.isIdle.bind(_assertThisInitialized(_this));
    return _possibleConstructorReturn(_this);
  }

  _createClass(c, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._bindEvents();

      var t = this.props.startOnMount;
      t && this.reset();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(t) {
      t.debounce !== this.props.debounce && (this._onAction = u(this._onAction, this.props.debounce)), t.throttle !== this.props.throttle && (this._onAction = l(this._onAction, this.props.throttle)), t.eventsThrottle !== this.props.eventsThrottle && (this._handleEvent = l(this._handleEvent, this.props.eventsThrottle));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.tId), this._unbindEvents(!0);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.children;
      return t || null;
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this2 = this;

      if (!s) return;
      var _this$props = this.props,
          t = _this$props.element,
          e = _this$props.events,
          n = _this$props.passive,
          i = _this$props.capture;
      this.eventsBound || (e.forEach(function (e) {
        t.addEventListener(e, _this2._handleEvent, {
          capture: i,
          passive: n
        });
      }), this.eventsBound = !0);
    }
  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      var _this3 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (!s) return;
      var _this$props2 = this.props,
          e = _this$props2.element,
          n = _this$props2.events,
          i = _this$props2.passive,
          r = _this$props2.capture;
      (this.eventsBound || t) && (n.forEach(function (t) {
        e.removeEventListener(t, _this3._handleEvent, {
          capture: r,
          passive: i
        });
      }), this.eventsBound = !1);
    }
  }, {
    key: "_toggleIdleState",
    value: function _toggleIdleState(t) {
      var _this4 = this;

      this.setState(function (t) {
        return {
          idle: !t.idle
        };
      }, function () {
        var _this4$props = _this4.props,
            e = _this4$props.onActive,
            n = _this4$props.onIdle,
            i = _this4$props.stopOnIdle,
            s = _this4.state.idle;
        s ? (i && (clearTimeout(_this4.tId), _this4.tId = null, _this4._unbindEvents()), n(t)) : i || (_this4._bindEvents(), e(t));
      });
    }
  }, {
    key: "_handleEvent",
    value: function _handleEvent(t) {
      var _this$state = this.state,
          e = _this$state.remaining,
          n = _this$state.pageX,
          i = _this$state.pageY,
          s = _this$state.idle,
          _this$props3 = this.props,
          r = _this$props3.timeout,
          o = _this$props3.stopOnIdle;
      if (this._onAction(t), e) return;

      if ("mousemove" === t.type) {
        if (t.pageX === n && t.pageY === i) return;
        if (void 0 === t.pageX && void 0 === t.pageY) return;
        if (this.getElapsedTime() < 200) return;
      }

      clearTimeout(this.tId), this.tId = null;
      var u = +new Date() - this.getLastActiveTime();
      (s && !o || !s && u > r) && this._toggleIdleState(t), this.setState({
        lastActive: +new Date(),
        pageX: t.pageX,
        pageY: t.pageY
      }), s && o || (this.tId = setTimeout(this._toggleIdleState, r));
    }
  }, {
    key: "reset",
    value: function reset() {
      clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
        idle: !1,
        oldDate: +new Date(),
        lastActive: +new Date(),
        remaining: null
      });
      var t = this.props.timeout;
      this.tId = setTimeout(this._toggleIdleState, t);
    }
  }, {
    key: "pause",
    value: function pause() {
      var t = this.state.remaining;
      null === t && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.setState({
        remaining: this.getRemainingTime()
      }));
    }
  }, {
    key: "resume",
    value: function resume() {
      var _this$state2 = this.state,
          t = _this$state2.remaining,
          e = _this$state2.idle;
      null !== t && (this._bindEvents(), e || (this.tId = setTimeout(this._toggleIdleState, t), this.setState({
        remaining: null,
        lastActive: +new Date()
      })));
    }
  }, {
    key: "getRemainingTime",
    value: function getRemainingTime() {
      var _this$state3 = this.state,
          t = _this$state3.remaining,
          e = _this$state3.lastActive,
          n = this.props.timeout;
      if (null !== t) return t < 0 ? 0 : t;
      var i = n - (+new Date() - e);
      return i < 0 ? 0 : i;
    }
  }, {
    key: "getElapsedTime",
    value: function getElapsedTime() {
      var t = this.state.oldDate;
      return +new Date() - t;
    }
  }, {
    key: "getLastActiveTime",
    value: function getLastActiveTime() {
      var t = this.state.lastActive;
      return t;
    }
  }, {
    key: "isIdle",
    value: function isIdle() {
      var t = this.state.idle;
      return t;
    }
  }]);

  return c;
}(t);

function a() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$timeout = _ref.timeout,
      t = _ref$timeout === void 0 ? 12e5 : _ref$timeout,
      _ref$element = _ref.element,
      i = _ref$element === void 0 ? r : _ref$element,
      _ref$events = _ref.events,
      c = _ref$events === void 0 ? o : _ref$events,
      _ref$onIdle = _ref.onIdle,
      a = _ref$onIdle === void 0 ? function () {} : _ref$onIdle,
      _ref$onActive = _ref.onActive,
      h = _ref$onActive === void 0 ? function () {} : _ref$onActive,
      _ref$onAction = _ref.onAction,
      d = _ref$onAction === void 0 ? function () {} : _ref$onAction,
      _ref$debounce = _ref.debounce,
      p = _ref$debounce === void 0 ? 0 : _ref$debounce,
      _ref$throttle = _ref.throttle,
      m = _ref$throttle === void 0 ? 0 : _ref$throttle,
      _ref$eventsThrottle = _ref.eventsThrottle,
      v = _ref$eventsThrottle === void 0 ? 200 : _ref$eventsThrottle,
      _ref$startOnMount = _ref.startOnMount,
      g = _ref$startOnMount === void 0 ? !0 : _ref$startOnMount,
      _ref$stopOnIdle = _ref.stopOnIdle,
      b = _ref$stopOnIdle === void 0 ? !1 : _ref$stopOnIdle,
      _ref$capture = _ref.capture,
      T = _ref$capture === void 0 ? !0 : _ref$capture,
      _ref$passive = _ref.passive,
      f = _ref$passive === void 0 ? !0 : _ref$passive;

  var A = e(!1),
      I = e(!0),
      _ = e(+new Date()),
      E = e(+new Date()),
      w = e(null),
      D = e(null),
      O = e(null),
      S = e(null),
      y = function y(t) {
    var e = !I.current;
    I.current = e, e ? (b && (clearTimeout(S.current), S.current = null, X()), a(t)) : b || (L(), h(t));
  };

  var M = function M(e) {
    if (d(e), w.current) return;

    if ("mousemove" === e.type) {
      if (e.pageX === D && e.pageY === O) return;
      if (void 0 === e.pageX && void 0 === e.pageY) return;
      if (B() < 200) return;
    }

    clearTimeout(S.current), S.current = null;
    var n = +new Date() - R();
    (I.current && !b || !I.current && n > t) && y(e), E.current = +new Date(), D.current = e.pageX, O.current = e.pageY, I.current && b || (S.current = setTimeout(y, t));
  };

  var L = function L() {
    s && (A.current || (c.forEach(function (t) {
      i.addEventListener(t, M, {
        capture: T,
        passive: f
      });
    }), A.current = !0));
  },
      X = function X() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    s && (A.current || t) && (c.forEach(function (t) {
      i.removeEventListener(t, M, {
        capture: T,
        passive: f
      });
    }), A.current = !1);
  },
      Y = function Y() {
    if (null !== w.current) return w.current < 0 ? 0 : w.current;
    var e = t - (+new Date() - E.current);
    return e < 0 ? 0 : e;
  },
      B = function B() {
    return +new Date() - _.current;
  },
      R = function R() {
    return E.current;
  },
      P = function P() {
    clearTimeout(S.current), S.current = null, L(), I.current = !1, _.current = +new Date(), E.current = +new Date(), w.current = null, S.current = setTimeout(y, t);
  };

  return n(function () {
    if (p > 0 && m > 0) throw new Error("onAction can either be throttled or debounced (not both)");
    return p > 0 && (d = u(d, p)), m > 0 && (d = l(d, m)), v > 0 && (M = l(M, v)), L(), g && P(), function () {
      clearTimeout(S.current), X(!0);
    };
  }, []), {
    isIdle: function isIdle() {
      return I.current;
    },
    pause: function pause() {
      null === w.current && (X(), clearTimeout(S.current), S.current = null, w.current = Y());
    },
    reset: P,
    resume: function resume() {
      null !== w.current && (L(), I.current || (S.current = setTimeout(y, w.current), w.current = null, E.current = +new Date()));
    },
    getLastActiveTime: R,
    getElapsedTime: B,
    getRemainingTime: Y
  };
}

c.propTypes = {
  timeout: i.number,
  events: i.arrayOf(i.string),
  onIdle: i.func,
  onActive: i.func,
  onAction: i.func,
  debounce: i.number,
  throttle: i.number,
  eventsThrottle: i.number,
  element: i.oneOfType([i.object, i.element]),
  startOnMount: i.bool,
  stopOnIdle: i.bool,
  passive: i.bool,
  capture: i.bool
}, c.defaultProps = {
  timeout: 12e5,
  element: r,
  events: o,
  onIdle: function onIdle() {},
  onActive: function onActive() {},
  onAction: function onAction() {},
  debounce: 0,
  throttle: 0,
  eventsThrottle: 200,
  startOnMount: !0,
  stopOnIdle: !1,
  capture: !0,
  passive: !0
}, a.propTypes = {
  timeout: i.number,
  events: i.arrayOf(i.string),
  onIdle: i.func,
  onActive: i.func,
  onAction: i.func,
  debounce: i.number,
  throttle: i.number,
  eventsThrottle: i.number,
  element: i.oneOfType([i.object, i.element]),
  startOnMount: i.bool,
  stopOnIdle: i.bool,
  passive: i.bool,
  capture: i.bool
}, a.defaultProps = {
  timeout: 12e5,
  element: r,
  events: o,
  onIdle: function onIdle() {},
  onActive: function onActive() {},
  onAction: function onAction() {},
  debounce: 0,
  throttle: 0,
  eventsThrottle: 200,
  startOnMount: !0,
  stopOnIdle: !1,
  capture: !0,
  passive: !0
};
export default c;
export { a as useIdleTimer };